import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import API from '../utils/api';

export default function ContactUs() {
  const [info, setInfo] = useState({
    contact_email: 'support@oexams.com',
    contact_phone: '',
    contact_whatsapp: '',
    contact_address: '',
    contact_city: 'India',
    contact_hours: 'Mon–Sat, 9 AM – 6 PM IST',
    contact_about: 'OExams is an online examination platform built for Indian educators. We help teachers and schools create, manage, and analyze exams digitally — saving time and improving the student experience.',
  });
  const [form, setForm] = useState({ name:'', email:'', phone:'', subject:'', message:'' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/admin/settings').then(r => {
      setInfo(prev => ({
        ...prev,
        contact_email:   r.data.contact_email   || prev.contact_email,
        contact_phone:   r.data.contact_phone   || prev.contact_phone,
        contact_whatsapp:r.data.contact_whatsapp|| prev.contact_whatsapp,
        contact_address: r.data.contact_address || prev.contact_address,
        contact_city:    r.data.contact_city    || prev.contact_city,
        contact_hours:   r.data.contact_hours   || prev.contact_hours,
        contact_about:   r.data.contact_about   || prev.contact_about,
      }));
    }).finally(() => setLoading(false));
  }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (!form.name || !form.email || !form.message) { alert('Please fill in Name, Email and Message.'); return; }
    const mailBody = `Name: ${form.name}%0AEmail: ${form.email}%0APhone: ${form.phone}%0ASubject: ${form.subject}%0A%0AMessage:%0A${form.message}`;
    window.location.href = `mailto:${info.contact_email}?subject=${encodeURIComponent(form.subject || 'Contact from OExams')}&body=${mailBody}`;
    setSubmitted(true);
  };

  const inputStyle = { width:'100%', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:8, padding:'10px 14px', color:'var(--text)', fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:'inherit' };
  const labelStyle = { display:'block', fontSize:13, fontWeight:600, color:'var(--text2)', marginBottom:6 };

  const faqs = [
    { q:'How do I create my first exam?', a:'After registering and subscribing, go to Exams → Create New Exam. Add questions manually or upload via Excel.' },
    { q:'Can students take exams on mobile?', a:'Yes! OExams is fully mobile-responsive. Students just need the exam link — no app required.' },
    { q:'How do I upgrade my subscription?', a:'Go to Dashboard → Subscribe Now. Choose a plan and submit your payment screenshot for quick approval.' },
    { q:'Is my exam data safe?', a:'Yes. All data is stored securely on our servers. We never share your exam content with third parties.' },
    { q:'Can I add my school logo to results?', a:'Yes! Go to PDF Branding in the menu to upload your logo and customize result sheets.' },
  ];

  // Build contact cards dynamically based on what admin has filled
  const contactCards = [
    info.contact_email    && { icon:'📧', label:'Email Support',    value: info.contact_email,    link: `mailto:${info.contact_email}` },
    info.contact_phone    && { icon:'📞', label:'Phone',            value: info.contact_phone,    link: `tel:${info.contact_phone}` },
    info.contact_whatsapp && { icon:'💬', label:'WhatsApp',         value: info.contact_whatsapp, link: `https://wa.me/${info.contact_whatsapp.replace(/\D/g,'')}` },
    info.contact_hours    && { icon:'🕐', label:'Support Hours',    value: info.contact_hours,    link: null },
    (info.contact_address || info.contact_city) && { icon:'📍', label:'Location', value: [info.contact_address, info.contact_city].filter(Boolean).join(', '), link: null },
  ].filter(Boolean);

  if (loading) return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <Navbar />
      <div style={{ color:'var(--text2)' }}>Loading...</div>
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)' }}>
      <Navbar />
      <div style={{ maxWidth:1000, margin:'0 auto', padding:'48px 20px 80px' }}>

        {/* Header */}
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontSize:48, marginBottom:16 }}>💬</div>
          <h1 style={{ fontSize:36, fontWeight:800, color:'var(--text)', marginBottom:12 }}>Contact Us</h1>
          <p style={{ color:'var(--text2)', fontSize:15, maxWidth:480, margin:'0 auto' }}>
            Have a question or need help? We're here for you. Reach out and we'll respond as soon as possible.
          </p>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(300px, 1fr))', gap:24, marginBottom:40 }}>

          {/* Contact Form */}
          <div className="card" style={{ padding:'32px' }}>
            <h2 style={{ fontSize:20, fontWeight:800, color:'var(--text)', marginBottom:24 }}>📩 Send us a Message</h2>
            {submitted ? (
              <div style={{ textAlign:'center', padding:'32px 0' }}>
                <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
                <h3 style={{ color:'var(--text)', marginBottom:8 }}>Message Sent!</h3>
                <p style={{ color:'var(--text2)', fontSize:14 }}>Thank you for reaching out. We'll get back to you within 24 hours.</p>
                <button onClick={() => { setSubmitted(false); setForm({ name:'', email:'', phone:'', subject:'', message:'' }); }} className="btn btn-secondary" style={{ marginTop:16 }}>Send Another</button>
              </div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div><label style={labelStyle}>Full Name *</label><input name="name" value={form.name} onChange={handleChange} placeholder="Your name" style={inputStyle} /></div>
                <div><label style={labelStyle}>Email Address *</label><input name="email" value={form.email} onChange={handleChange} placeholder="your@email.com" type="email" style={inputStyle} /></div>
                <div><label style={labelStyle}>Phone Number</label><input name="phone" value={form.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" style={inputStyle} /></div>
                <div><label style={labelStyle}>Subject</label><input name="subject" value={form.subject} onChange={handleChange} placeholder="e.g. Subscription help" style={inputStyle} /></div>
                <div><label style={labelStyle}>Message *</label><textarea name="message" value={form.message} onChange={handleChange} placeholder="Describe your issue or question..." rows={5} style={inputStyle} /></div>
                <button onClick={handleSubmit} className="btn btn-primary" style={{ padding:'12px', fontSize:15, fontWeight:700 }}>📧 Send Message</button>
              </div>
            )}
          </div>

          {/* Contact Info */}
          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <h2 style={{ fontSize:20, fontWeight:800, color:'var(--text)', margin:0 }}>📌 Contact Information</h2>

            {contactCards.map((c, i) => (
              <div key={i} className="card" style={{ padding:'20px 24px', display:'flex', alignItems:'center', gap:16 }}>
                <div style={{ fontSize:28, flexShrink:0 }}>{c.icon}</div>
                <div>
                  <div style={{ fontSize:12, color:'var(--text3)', fontWeight:600, marginBottom:2 }}>{c.label}</div>
                  {c.link
                    ? <a href={c.link} style={{ color:'var(--primary-light)', fontWeight:700, fontSize:15, textDecoration:'none' }}>{c.value}</a>
                    : <div style={{ color:'var(--text)', fontWeight:600, fontSize:14 }}>{c.value}</div>
                  }
                </div>
              </div>
            ))}

            {/* About text from admin */}
            {info.contact_about && (
              <div className="card" style={{ padding:'24px', background:'rgba(99,102,241,0.08)', border:'1px solid rgba(99,102,241,0.25)' }}>
                <h3 style={{ fontWeight:700, color:'var(--text)', marginBottom:12, fontSize:15 }}>🏢 About OExams</h3>
                <p style={{ color:'var(--text2)', fontSize:13, lineHeight:1.7, margin:0 }}>{info.contact_about}</p>
              </div>
            )}

            {/* Quick Links */}
            <div className="card" style={{ padding:'24px' }}>
              <h3 style={{ fontWeight:700, color:'var(--text)', marginBottom:14, fontSize:15 }}>🔗 Quick Links</h3>
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {[
                  { label:'📜 Privacy Policy',    href:'/#/privacy-policy' },
                  { label:'⚖️ Terms & Conditions', href:'/#/terms' },
                  { label:'📝 Register',           href:'/#/register' },
                  { label:'🔑 Login',              href:'/#/login' },
                ].map((l, i) => (
                  <a key={i} href={l.href} style={{ color:'var(--text2)', textDecoration:'none', fontSize:13, padding:'6px 0', borderBottom:'1px solid var(--border)', display:'block' }}>{l.label}</a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="card" style={{ padding:'32px' }}>
          <h2 style={{ fontSize:22, fontWeight:800, color:'var(--text)', marginBottom:24, textAlign:'center' }}>❓ Frequently Asked Questions</h2>
          <div style={{ display:'flex', flexDirection:'column' }}>
            {faqs.map((faq, i) => (
              <div key={i} style={{ padding:'18px 0', borderBottom: i < faqs.length-1 ? '1px solid var(--border)' : 'none' }}>
                <div style={{ fontWeight:700, color:'var(--text)', fontSize:14, marginBottom:6 }}>Q: {faq.q}</div>
                <div style={{ color:'var(--text2)', fontSize:13, lineHeight:1.7 }}>A: {faq.a}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
